var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "article",
        [
          !_vm.isLightPlan
            ? _c(
                "job-preview-company-introduction",
                _vm._g(
                  {
                    attrs: {
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "comment-highlights": _vm.getAnyCommentHighlights(
                        _vm.targetIdMap.companyInfo.intro.prefix
                      ),
                      "text-counts": _vm.textCounts.intro,
                      "catch-copy": _vm.companyInfo.catchCopy,
                      text: _vm.companyInfo.introText,
                      image: _vm.companyInfo.introImage,
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "会社名",
                  value: _vm.companyInfo.name,
                  "data-test": "name",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "事業内容",
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.companyInfo.businessContent
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": [
                    _vm.getTextCount(
                      "事業内容",
                      _vm.companyInfo.businessContent,
                      _vm.targetIdMap.companyInfo.businessContent
                    ),
                  ],
                  "target-id": _vm.targetIdMap.companyInfo.businessContent,
                  value: _vm.companyInfo.businessContent,
                  "data-test": "businessContent",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _vm.companyInfo.established
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "設立",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.established
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "設立",
                          _vm.companyInfo.established,
                          _vm.targetIdMap.companyInfo.established
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.established,
                      value: _vm.companyInfo.established,
                      "data-test": "established",
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.companyInfo.capital
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "資本金",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.capital
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "資本金",
                          _vm.companyInfo.capital,
                          _vm.targetIdMap.companyInfo.capital
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.capital,
                      value: _vm.companyInfo.capital,
                      "data-test": "capital",
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.companyInfo.sale
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "売上高",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.sale
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "売上高",
                          _vm.companyInfo.sale,
                          _vm.targetIdMap.companyInfo.sale
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.sale,
                      value: _vm.companyInfo.sale,
                      "data-test": "sale",
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isShow.employee
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "従業員数",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.employeeNumber
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "従業員数",
                          _vm.companyInfo.employeeNumber,
                          _vm.targetIdMap.companyInfo.employeeNumber
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.employeeNumber,
                      value: _vm.companyInfo.employeeNumber,
                      "data-test": "employeeNumber",
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.companyInfo.averageAge ||
                        _vm.companyInfo.midCareerPercentage
                          ? {
                              key: "sub",
                              fn: function () {
                                return [
                                  _vm.companyInfo.averageAge
                                    ? _c(
                                        "job-preview-content-sub",
                                        _vm._g(
                                          {
                                            attrs: {
                                              title: "平均年齢",
                                              "comment-highlights":
                                                _vm.getCommentHighlights(
                                                  _vm.targetIdMap.companyInfo
                                                    .averageAge
                                                ),
                                              "text-count-mode":
                                                _vm.textCountMode,
                                              "highlight-mode":
                                                _vm.highlightMode,
                                              "text-counts": [
                                                _vm.getTextCount(
                                                  "平均年齢",
                                                  _vm.companyInfo.averageAge,
                                                  _vm.targetIdMap.companyInfo
                                                    .averageAge
                                                ),
                                              ],
                                              "target-id":
                                                _vm.targetIdMap.companyInfo
                                                  .averageAge,
                                              value: _vm.companyInfo.averageAge,
                                              "data-test": "averageAge",
                                            },
                                          },
                                          _vm.$listeners
                                        )
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.companyInfo.midCareerPercentage
                                    ? _c(
                                        "job-preview-content-sub",
                                        _vm._g(
                                          {
                                            attrs: {
                                              title: "中途入社者の割合",
                                              "comment-highlights":
                                                _vm.getCommentHighlights(
                                                  _vm.targetIdMap.companyInfo
                                                    .midCareerPercentage
                                                ),
                                              "text-count-mode":
                                                _vm.textCountMode,
                                              "highlight-mode":
                                                _vm.highlightMode,
                                              "text-counts": [
                                                _vm.getTextCount(
                                                  "中途入社者の割合",
                                                  _vm.companyInfo
                                                    .midCareerPercentage,
                                                  _vm.targetIdMap.companyInfo
                                                    .midCareerPercentage
                                                ),
                                              ],
                                              "target-id":
                                                _vm.targetIdMap.companyInfo
                                                  .midCareerPercentage,
                                              value:
                                                _vm.companyInfo
                                                  .midCareerPercentage,
                                              "data-test":
                                                "midCareerPercentage",
                                            },
                                          },
                                          _vm.$listeners
                                        )
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isShow.representative
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "代表者",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.representative
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "代表者",
                          _vm.companyInfo.representative,
                          _vm.targetIdMap.companyInfo.representative
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.representative,
                      value: _vm.companyInfo.representative,
                      "data-test": "representative",
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.companyInfo.representativeProfile
                          ? {
                              key: "sub",
                              fn: function () {
                                return [
                                  _c(
                                    "job-preview-content-sub",
                                    _vm._g(
                                      {
                                        attrs: {
                                          title: "代表者略歴",
                                          "comment-highlights":
                                            _vm.getCommentHighlights(
                                              _vm.targetIdMap.companyInfo
                                                .representativeProfile
                                            ),
                                          "text-count-mode": _vm.textCountMode,
                                          "highlight-mode": _vm.highlightMode,
                                          "text-counts": [
                                            _vm.getTextCount(
                                              "代表者略歴",
                                              _vm.companyInfo
                                                .representativeProfile,
                                              _vm.targetIdMap.companyInfo
                                                .representativeProfile
                                            ),
                                          ],
                                          "target-id":
                                            _vm.targetIdMap.companyInfo
                                              .representativeProfile,
                                          value:
                                            _vm.companyInfo
                                              .representativeProfile,
                                          "data-test": "representativeProfile",
                                        },
                                      },
                                      _vm.$listeners
                                    )
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.companyInfo.note
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  {
                    attrs: {
                      title: "備考",
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.companyInfo.note
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          "備考",
                          _vm.companyInfo.note,
                          _vm.targetIdMap.companyInfo.note
                        ),
                      ],
                      "target-id": _vm.targetIdMap.companyInfo.note,
                      value: _vm.companyInfo.note,
                      "data-test": "note",
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.companyInfo.hp
            ? _c(
                "job-preview-content-outline",
                _vm._g(
                  { attrs: { title: "企業HP", "data-test": "hp" } },
                  _vm.$listeners
                ),
                [
                  _c(
                    "job-preview-content",
                    _vm._g(
                      {
                        attrs: {
                          "comment-highlights": _vm.getCommentHighlights(
                            _vm.targetIdMap.companyInfo.hp
                          ),
                          "highlight-mode": _vm.highlightMode,
                          "data-test": "hp-content",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c(
                                    "p",
                                    { staticClass: "clearfix" },
                                    [
                                      _c(_vm.tag, {
                                        tag: "component",
                                        class: {
                                          "text-underline": _vm.highlightMode,
                                        },
                                        attrs: {
                                          id: _vm.targetIdMap.companyInfo.hp,
                                          href: _vm.companyInfo.hp,
                                          rel: "nofollow",
                                          target: "blank",
                                          "data-test": "value",
                                        },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.companyInfo.hp
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3731867024
                        ),
                      },
                      _vm.$listeners
                    )
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isLightPlan
        ? _c(
            "job-preview-company-images",
            _vm._g(
              {
                attrs: {
                  "highlight-mode": _vm.highlightMode,
                  "text-count-mode": _vm.textCountMode,
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.companyInfo.images.prefix
                  ),
                  "text-counts": _vm.textCounts.images(),
                  "company-info": _vm.companyInfo,
                },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }